/* Text styles */
._OrganizationListView_moa9t_2 ._header_moa9t_2 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
._OrganizationListView_moa9t_2 ._header_moa9t_2 ._createButton_moa9t_7 {
  margin-left: auto;
}
._OrganizationListView_moa9t_2 ._table_moa9t_10 ._nameCell_moa9t_10 {
  color: #3996e0;
  cursor: pointer;
}